<template>
  <div class="container" v-if="$route.name == 'Tram'">
    <Header></Header>
    <main class="wrapper">
      <Menu v-if="$store.state.display_width >= 768"></Menu>
      <div class="product-refrigerator">
        <section class="product-refrigerator__header">
          <div>
            <BreadCrumbs></BreadCrumbs>
            <h1 class="different-color">Оборудование для трамваев</h1>
          </div>
          <div>
            <img src="@/assets/img/png/OurProducts/imageTram.png" alt="product">
          </div>
        </section>
        <div class="__header__products">
          <router-link class="__item" to="/ourproducts/tram/tramPKTS">
            <span>Трамвайные вагоны <span v-if="$store.state.display_width < 768">ПКТС</span></span>
            <h2 class="different-color" v-if="$store.state.display_width >= 768">пктс</h2>
            <span>ТТ952.85.25.000 Система кондиционирования воздуха СКВ 24-2500-11У1</span>
            <div class="__products__button-container"><span>Подробнее</span>
              <div><img src="@/assets/img/svg/arrow_right.svg" alt="button"></div>
            </div>
          </router-link>
          <router-link class="__item" to="/ourproducts/tram/tramUKVZ">
            <span>Трамвайные вагоны <span v-if="$store.state.display_width < 768">УКВЗ</span></span>
            <h2 class="different-color" v-if="$store.state.display_width >= 768">Уквз</h2>
            <span>ТТ633.85.25.000 Система кондиционирования воздуха СКВ 24-2500-11У1</span>
            <div class="__products__button-container"><span>Подробнее</span>
              <div><img src="@/assets/img/svg/arrow_right.svg" alt="button"></div>
            </div>
          </router-link>
        </div>
        <section class="company-products">
          <h2>
            С <span>2008</span> г. разработана и поставлена на производство следующая продукция для трамваев:
          </h2>
          <div class="schema">
            <div class="__description">
              <div class="__elem">
                <div class="__item">
                  <div>
                    Отопители салона и кабины
                  </div>
                </div>
                <div class="__item">
                  <div>
                    Системы кондиционирования воздуха кабины и салона  трамвайных вагонов моделей 71-633, 71-623, 71-619
                  </div>
                  <div>
                    (заказчик ФГУП «УКВЗ»)
                  </div>
                </div>
              </div>
              <div class="__elem">
                <div class="__item">
                  <div>
                    Системы кондиционирования воздуха кабины и салона трамвайных вагонов моделей 71-911, 71-931, 71-911Е
                  </div>
                  <div>
                    (заказчик ООО «ПКТС»)
                  </div>
                </div>
                <div class="__item">
                  <div>
                    Преобразователь напряжения для питания кондиционера салона трамвая всех серий и индексов
                  </div>
                  <div>
                    (заказчик ФГУП «УКВЗ», предприятия горэлектротранспорта), ПКТС
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
    <footer-menu></footer-menu>
  </div>
  <div v-else>
    <router-view></router-view>
  </div>
</template>

<script>
import BreadCrumbs from "@/components/BreadCrumbs";
import Header from "@/components/Header";
import FooterMenu from "@/components/FooterMenu";
import Menu from "@/components/Menu/Menu";

export default {
  components: {BreadCrumbs, Header, FooterMenu, Menu},
  name: 'Tram'
}
</script>

<style scoped lang="scss">
img {
  max-width: 100%;
}

.product-refrigerator__header {
  display: flex;
  justify-content: space-between;
  margin-bottom: rem(40);

  .different-color {
    font-weight: 700;
    font-size: 40px;
    line-height: 50px;
    margin-top: rem(40);
  }
}

.product-refrigerator__main-info {
  max-width: rem(640);

  h2 {
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    letter-spacing: 0.02em;
  }
}

.__header__products {
  display: flex;
  flex-direction: column;
  row-gap: rem(32);
  max-width: rem(662);

  .__item {
    max-width: rem(354);
    background: #FFFFFF;
    box-shadow: 0px 8px 32px rgba(18, 17, 39, 0.08);
    border-radius: rem(12);
    padding: rem(32) rem(24);

    h2 {
      font-weight: 700;
      font-size: rem(40);
      line-height: rem(50);
      letter-spacing: 0.03em;
      text-transform: uppercase;
    }

    & > span:first-child {
      display: block;
      font-weight: 600;
      font-size: rem(24);
      line-height: rem(30);
      letter-spacing: 0.02em;
      color: #93383D;
    }

    & > span:last-child {
      display: block;
      margin: rem(16) 0;
      font-style: italic;
      font-weight: 400;
    }

    &:first-child {
      align-self: flex-end;
    }

    .__products__button-container {
      display: flex;
      align-items: center;
      gap: rem(24);
      color: #8A8887;
    }
  }
}

.company-products {
  margin-top: rem(40);
  margin-bottom: rem(56);

  h2 {
    font-weight: 600;
    font-size: 24px;
    letter-spacing: 0.02em;
    max-width: rem(624);

    span {
      color: #93383d;
    }
  }

  .schema {
    margin-top: rem(40);
    overflow: hidden;
    overflow-x: auto;
  }

  .__description {
    width: rem(1280);

    .__elem {
      display: flex;

      .__item {
        position: relative;
        font-style: italic;
        font-weight: 400;
        line-height: 22px;
        border-left: 2px solid #93383d;
        width: rem(413);
        padding: rem(26) 0 0 rem(24);

        &::before {
          content: '';
          position: absolute;
          left: rem(-8);
          border-radius: 50%;
          background-color: #93383d;
          width: rem(16);
          height: rem(16);
        }

        & > div {
          max-width: rem(316);
        }

        & > div:first-child {
          font-weight: 600;
          line-height: rem(20);
        }

        & > div:last-child {
          margin-top: rem(8);
          font-style: italic;
          line-height: rem(20);
        }
      }

      &:first-child {
        align-items: flex-end;
        border-bottom: 2px solid #93383d;

        .__item {
          height: rem(168);

          &:before {
            top: 0;
          }

          &:first-child {
            margin-left: rem(328);
          }
        }
      }

      &:last-child {
        align-items: flex-start;

        .__item {
          height: rem(168);

          &:before {
            bottom: 0;
          }

          &:first-child {
            margin-left: rem(126);
          }

          &:last-child {
            padding-right: rem(40);
          }
        }
      }
    }
  }
}

@media (max-width: em(1024, 16)) and (min-width: em(768, 16)) {
  .product-refrigerator__header {
    margin-bottom: calc(1.25rem + (40 - 20) * ((100vw - 48rem) / (1024 - 768)));

    .different-color {
      font-size: calc(2rem + (40 - 32) * ((100vw - 48rem) / (1024 - 768)));
      line-height: calc(2.5rem + (50 - 40) * ((100vw - 48rem) / (1024 - 768)));
      margin-top: calc(0rem + (40 - 0) * ((100vw - 48rem) / (1024 - 768)));
    }
  }
}

@media (max-width: em(767, 16)) {
  .product-refrigerator__header {
    flex-direction: column;

    .different-color {
      margin-top: 0;
    }
  }
}

@media (max-width: em(767, 16)) and (min-width: em(320, 16)) {
  .product-refrigerator__header {
    row-gap: calc(1.5rem + (40 - 24) * ((100vw - 20rem) / (767 - 320)));

    .different-color {
      max-width: calc(18rem + (628 - 288) * ((100vw - 20rem) / (767 - 320)));
      font-size: calc(1.25rem + (40 - 20) * ((100vw - 20rem) / (767 - 320)));
      line-height: calc(1.5625rem + (40 - 25) * ((100vw - 20rem) / (767 - 320)));
    }

    div {
      padding-left: calc(1.625rem + (81 - 26) * ((100vw - 20rem) / (767 - 320)));
    }
  }
  .__header__products {
    align-self: flex-end;
    width: calc(18rem + (662 - 288) * ((100vw - 20rem) / (768 - 320)));

    .__item {
      max-width: calc(8.5rem + (354 - 136) * ((100vw - 20rem) / (768 - 320)));
      padding: calc(0.5rem + (32 - 8) * ((100vw - 20rem) / (768 - 320))) calc(0.5rem + (24 - 8) * ((100vw - 20rem) / (768 - 320)));

      & > span:first-child {
        font-size: calc(0.75rem + (24 - 12) * ((100vw - 20rem) / (768 - 320)));
        line-height: calc(0.9375rem + (30 - 15) * ((100vw - 20rem) / (768 - 320)));
      }

      & > span:nth-child(2) {
        margin: calc(0.5rem + (16 - 8) * ((100vw - 20rem) / (768 - 320))) 0;
        font-size: calc(0.625rem + (16 - 10) * ((100vw - 20rem) / (768 - 320)));
      }
    }
  }
  .__products__button-container {
    font-size: calc(0.625rem + (16 - 10) * ((100vw - 20rem) / (768 - 320)));
  }
  .company-products {
    .__description {
      .__elem {
        .__item {
          font-size: calc(0.75rem + (16 - 12) * ((100vw - 20rem) / (768 - 320)));

          & > div:first-child {
            font-size: calc(0.75rem + (16 - 12) * ((100vw - 20rem) / (768 - 320)));
            line-height: calc(0.9375rem + (20 - 15) * ((100vw - 20rem) / (768 - 320)));
          }

          & > div:last-child {
            font-size: calc(0.625rem + (16 - 10) * ((100vw - 20rem) / (768 - 320)));
            line-height: calc(0.8125rem + (20 - 13) * ((100vw - 20rem) / (768 - 320)));
          }
        }
      }

      .__elem:first-child {
        .__item {
          height: calc(4.375rem + (168 - 70) * ((100vw - 20rem) / (768 - 320)));

          &:first-child {
            margin-left: calc(5.125rem + (328 - 82) * ((100vw - 20rem) / (768 - 320)));
          }
        }
      }

      .__elem:last-child {
        .__item {
          height: calc(4.375rem + (168 - 70) * ((100vw - 20rem) / (768 - 320)));

          &:first-child {
            margin-left: calc(0.375rem + (126 - 6) * ((100vw - 20rem) / (768 - 320)));
          }
        }
      }
    }
  }
}

@media (max-width: em(320, 16)) and (min-width: em(220, 16)) {
  .product-refrigerator__header {
    row-gap: calc(1rem + (24 - 16) * ((100vw - 13.75rem) / (320 - 220)));

    .different-color {
      max-width: calc(12.5rem + (288 - 200) * ((100vw - 13.75rem) / (320 - 220)));
      font-size: calc(1em + (20 - 16) * ((100vw - 13.75rem) / (320 - 220)));
      line-height: calc(1.1875em + (25 - 19) * ((100vw - 13.75rem) / (320 - 220)));
    }

    div {
      padding-left: calc(0.6255em + (26 - 19) * ((100vw - 13.75rem) / (320 - 220)));
    }
  }
  .__header__products {
    align-self: flex-end;
    max-width: rem(288);

    .__item {
      padding: rem(8);
      max-width: rem(136);

      h2 {
        font-size: rem(12);
      }

      & > span:first-child {
        font-size: rem(12);
        line-height: rem(15);
      }

      & > span:nth-child(2) {
        margin: rem(8) 0;
        font-size: rem(10);
      }

      & > span:nth-child(3) {
        margin: rem(8) 0;
        font-size: rem(10);
      }
    }
  }
  .company-products {
    .__description {
      .__elem {
        .__item {
          font-size: rem(12);

          & > div:first-child {
            font-size: rem(12);
            line-height: rem(15);
          }

          & > div:last-child {
            font-size: rem(10);
            line-height: rem(13);
          }
        }
      }

      .__elem:first-child {
        .__item {
          height: rem(70);

          &:first-child {
            margin-left: rem(82);
          }
        }
      }

      .__elem:last-child {
        .__item {
          height: rem(70);

          &:first-child {
            margin-left: rem(6);
          }
        }
      }
    }
  }
}
</style>